<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>HPP</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td>Persediaan Barang Dagang</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPExport } from '../../lib/httplib'
export default {
  data () {
    return {
      data: {}
    }
  },
  components: {},
  created () {
    this.getList(1)
  },
  methods: {
    changePage (page) {
      this.getList(page)
    },
    getList (page) {
      HTTPExport.get(`/api/balance/purchase?page=${page}&size=10`).then(res => {
        this.data = res.data
        this.$router.push({ query: { page: page } })
      })
    }
  }
}
</script>